import Grid from '@mui/material/Grid';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { ApplyNowButton } from 'src/features/product-card/ApplyNowButton';
export default function ReviewApplyNow() {
  const {
    marketplaceEntity,
    shouldOmitCta
  } = useReviewContext();

  // Offer is already transformed by ReviewProvider via client islands pattern
  const {
    details: {
      applyLink,
      applyPhoneNumber,
      isActive,
      isMonetizing,
      reviewLink,
      versionId
    },
    institution: {
      name: institutionName
    },
    showCTA,
    name,
    displayName,
    ctaAnalytics
  } = marketplaceEntity;
  if (shouldOmitCta || !showCTA) {
    return null;
  }
  return <Grid display="inline-block" sx={theme => ({
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
      width: '100%'
    }
  })} size={{
    xs: 12,
    md: 9
  }}>
      <ApplyNowButton analytics={{
      ...ctaAnalytics,
      productPosition: 1,
      section: {
        ...ctaAnalytics.section,
        name: 'review_how_to_decide',
        position: 0
      },
      linkType: 'APPLY_NOW_BUTTON'
    }} id="Footer-MarketplaceApplyNow" isActive={isActive} isMonetizing={isMonetizing} applyLink={applyLink} reviewLink={reviewLink} applyPhoneNumber={applyPhoneNumber} institutionName={institutionName} ctaType="APPLY_NOW_BUTTON" versionId={versionId} linkSx={({
      palette: {
        primary
      }
    }) => ({
      '&:hover': {
        backgroundColor: primary.dark
      }
    })} name={displayName || name} />
    </Grid>;
}